// The composer remembers the last "who can see" choice per browser, so a
// manager who always posts to members only does not pick it again on every
// post. The schedule is never remembered (every new post starts on "publish
// now"). Per-viewer convenience only: every read and write is guarded, and
// the form works without it.
const STORAGE_KEY = "ginastee-publish-post";

// Only these keys are kept; anything else (e.g. a schedule stored by an
// earlier build) is dropped on the next write.
const KEPT_KEYS = ["visibility"];

function pick(source) {
    return KEPT_KEYS.reduce((acc, key) => {
        if (source && source[key] !== undefined) acc[key] = source[key];
        return acc;
    }, {});
}

export function readPreferences() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        return parsed && typeof parsed === "object" ? pick(parsed) : {};
    } catch (e) {
        return {};
    }
}

export function writePreferences(patch) {
    try {
        window.localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify(pick({ ...readPreferences(), ...patch }))
        );
    } catch (e) {
        // Storage may be unavailable (private mode, quota); the choice still applies to this post.
    }
}
